<div class="login-page">
  <form class="login-form" [formGroup]="loginForm" (ngSubmit)="login()">
    <h1>Admin Login</h1>

    <mat-form-field appearance="fill">
      <mat-label>Mandant</mat-label>
      <input matInput formControlName="tenant_id" autocomplete="organization" />
      <mat-error
        *ngIf="
          loginForm.controls.tenant_id.touched &&
          loginForm.controls.tenant_id.hasError('required')
        "
      >
        Bitte gib den Mandanten ein.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>E-Mail</mat-label>
      <input matInput formControlName="email" autocomplete="username" />
      <mat-error
        *ngIf="
          loginForm.controls.email.touched &&
          loginForm.controls.email.hasError('required')
        "
      >
        Bitte gib deine E-Mail-Adresse ein.
      </mat-error>
      <mat-error
        *ngIf="
          loginForm.controls.email.touched &&
          loginForm.controls.email.hasError('email')
        "
      >
        Bitte gib eine gueltige E-Mail-Adresse ein.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Passwort</mat-label>
      <input
        type="password"
        matInput
        formControlName="password"
        autocomplete="current-password"
      />
      <mat-error
        *ngIf="
          loginForm.controls.password.touched &&
          loginForm.controls.password.hasError('required')
        "
      >
        Bitte gib dein Passwort ein.
      </mat-error>
    </mat-form-field>

    <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>

    <button mat-flat-button color="primary" type="submit" [disabled]="loading">
      <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
      <span *ngIf="!loading">Einloggen</span>
    </button>
  </form>
</div>
